import type { SectionSpecItem } from "@/shared/models/SectionSpec";
import { GAUGE_CODES } from "../constants/inspectionChecks";

/** Same rule as the report's "No Specification" chip: no Min or Max anywhere. */
export const hasNoDimensionTolerances = (items: SectionSpecItem[]): boolean => {
	// Gauges carry Min/Max even though they are read as Go/No Go.
	const dimensions = items.filter(
		(item) =>
			item.Applies &&
			(item.ValueTypeCode === "V" || GAUGE_CODES.has(item.Code)),
	);
	return (
		dimensions.length > 0 &&
		dimensions.every((item) => item.Ltl === null && item.Utl === null)
	);
};
